"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _Logger = _interopRequireDefault(require("../Logger"));
/**
 * Copyright 2016-present, Deloitte Digital.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactDomFactory = /*#__PURE__*/function () {
  function ReactDomFactory() {
    (0, _classCallCheck2.default)(this, ReactDomFactory);
  }
  (0, _createClass2.default)(ReactDomFactory, null, [{
    key: "inject",
    value:
    /**
    * Injects a react component
    * @param {object}			module		- The react component
    * @param {object}			props		- Props to initiate component with
    * @param {HTMLElement}		target		- The target element to inject to
    */
    function inject(module) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var target = arguments.length > 2 ? arguments[2] : undefined;
      if (target) {
        _reactDom.default.render(_react.default.createElement(module, props || {}), target);
      } else {
        _Logger.default.warn('RHW07', 'Target element is null or undefined.');
      }
    }

    /**
     *  Disposes a react component
     * @param {HTMLElement}		target		- The target element to dispose
     */
  }, {
    key: "dispose",
    value: function dispose(target) {
      if (target) {
        _reactDom.default.unmountComponentAtNode(target);
      }
    }
  }]);
  return ReactDomFactory;
}();
exports.default = ReactDomFactory;